import { TextRun } from 'docx';
import type { NodeEntry } from 'slate';
import { Text } from 'slate';

import { isCheckboxCheckedText } from '../../../../constants';
import type { CheckboxElement } from '../../../../slate-api';
import type { DOCXInline } from '../text';

const CHECKBOX_CHECKED_SYMBOL = '☑';
const CHECKBOX_UNCHECKED_SYMBOL = '☐';

function isCheckboxChecked(checkbox: CheckboxElement): boolean {
  const stateText = checkbox.children.at(0);
  return Text.isText(stateText) && isCheckboxCheckedText(stateText.text);
}

export function createCheckboxField(checkboxEntry: NodeEntry<CheckboxElement>): DOCXInline[] {
  const [checkbox] = checkboxEntry;
  const symbol = isCheckboxChecked(checkbox) ? CHECKBOX_CHECKED_SYMBOL : CHECKBOX_UNCHECKED_SYMBOL;

  return [new TextRun({ text: symbol })];
}
